var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPrivacyPolicy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7V2H2V18H8.056C8.384 18.417 8.78 18.785 9.236 19.085L10.626 20H0.993C0.729813 20 0.477391 19.8955 0.291196 19.7095C0.105001 19.5235 0.000265042 19.2712 0 19.008V0.992C0 0.455 0.449 0 1.002 0H11.997L18 6V7H11ZM9 9H18V14.949C18 15.939 17.499 16.865 16.664 17.414L13.5 19.498L10.336 17.414C9.92663 17.1461 9.59023 16.7807 9.35703 16.3506C9.12383 15.9205 9.00115 15.4392 9 14.95V9ZM11 14.949C11 15.265 11.162 15.563 11.436 15.744L13.5 17.104L15.564 15.744C15.6969 15.6581 15.8064 15.5404 15.8825 15.4016C15.9586 15.2628 15.999 15.1073 16 14.949V11H11V14.949Z",
    fill: "#131313"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrivacyPolicy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/privacyPolicy.b0355e4e.svg";
export { ForwardRef as ReactComponent };